import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../../util/classNameConstructor";
import Icon from "../../core/icon/Icon";

const MapPlaceholder = ({ onClick, className }) => {
  const { t } = useTranslation();
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      onClick={onClick}
      className={cn(
        "bg-surface-subdued hover:border-action-primary-default hover:bg-surface-highlight-subdued flex h-full min-h-full w-full  cursor-pointer items-center justify-center rounded-2xl hover:border-2",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center gap-6">
        <Icon name="map-alt" transform="scale(1.5)" />
        <div className="flex gap-2">
          <span className="body-md">
            {t("util:add", { val: t("global:map") })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MapPlaceholder;
